import React from "react";
import { useDeviceType } from "../../../../components/customHooks/useDeviceType";
import "./profile.m.css";

const Profile = ({
  image,
  name,
  role,
  isSpeakerProfile = false,
  divider = false,
  imageWidth,
  imageHeight,
  isFireSideProfile,
}) => {
  const isMobile = useDeviceType() !== "desktop";
  const defaultImageStyle = { backgroundImage: `url(${image})` };
  imageWidth && (defaultImageStyle.width = imageWidth);
  imageHeight && (defaultImageStyle.height = imageHeight);
  const speakerStyles = isSpeakerProfile
    ? isMobile
      ? { backgroundImage: `url(${image})`, height: "auto" }
      : { backgroundImage: `url(${image})`, height: "250px" }
    : defaultImageStyle;

  const firesideImageStyles = isMobile
    ? { backgroundImage: `url(${image})`, width: "auto" }
    : { backgroundImage: `url(${image})`, height: "284px" };

  return isFireSideProfile ? (
    <>
      <div styleName="fireside-profile">
        <div styleName="fire-side-image" style={firesideImageStyles}></div>
        <div styleName="fireside-frame">
          <div styleName="fireside-title" dangerouslySetInnerHTML={{ __html: name }} />
          <div styleName="fireside-role" dangerouslySetInnerHTML={{ __html: role }} />
        </div>
      </div>
      {divider && <div styleName="divider" />}
    </>
  ) : (
    <>
      <div styleName={`${isSpeakerProfile ? "small-profile-speakers-winner" : "speakers-winner"}`}>
        <div styleName={`image`} style={speakerStyles}></div>
        <div styleName="frame">
          <div
            dangerouslySetInnerHTML={{ __html: name }}
            styleName={`${isSpeakerProfile ? "small-profile-heading-sam-altman" : "heading-sam-altman"}`}
          />
          <div
            dangerouslySetInnerHTML={{ __html: role }}
            styleName={`${isSpeakerProfile ? "small-profile-text-wrapper" : "text-wrapper"}`}
          />
        </div>
      </div>
      {divider && <div styleName="divider" />}
    </>
  );
};

export default Profile;
